import { ApiResponseType } from './api';
import { ApiLoginResponseType } from './api';
import { axiosInstance } from './index';

import axios from 'axios';

export const authService = {
   
   
    async orgLogin( data: any) {
        const { data: responseData } = await axios.post(process.env.REACT_APP_API_URL+`/auth/org/login`,data);
        return responseData as ApiLoginResponseType;
    },

   async adminLogin( data: any) {
        const { data: responseData } = await axios.post(process.env.REACT_APP_API_URL+`/auth/admin/login`,data);
        return responseData as ApiLoginResponseType;
    },
    async getMaskedEmailByMobile(mobile: string){
        const { data: responseData } = await axios.get(process.env.REACT_APP_API_URL+`/getEmailByMobile/${mobile}`);
        return responseData as ApiLoginResponseType;
    },
    async verifyEmail(mobile: string, email: string){
                const { data: responseData } =await axios.post(process.env.REACT_APP_API_URL+`/verifyEmail/${mobile}/${email}`);
            return responseData as ApiLoginResponseType;
    },
    async validateToken(token: string) {
            const { data: responseData } =await axios.get(process.env.REACT_APP_API_URL+`/auth/validate-reset-token`, {params: { token },});
            return responseData as ApiLoginResponseType;
    },
    async resetPassword(token: string, newPassword: string) {
    const { data: responseData } =await axios.post(process.env.REACT_APP_API_URL+`/auth/reset-password`, null, {params: { token, newPassword }});
    return responseData as ApiLoginResponseType;
    }
    
};